// @flow
import { TOGGLE_TIPS } from "./types";
import type { Action } from "../actions/types";

export const toggleTips = (state: boolean): Action => ({
  type: TOGGLE_TIPS,
  payload: state
});
